import { Routes, Route } from 'react-router-dom'
import MainLayout from '../layouts/MainLayout'
import HomePage from '../pages/HomePage'
import AboutPage from '../pages/AboutPage'
import PlcPage from '../pages/PlcPage'
import StoriesPage from '../pages/StoriesPage'
import StoryDetailPage from '../pages/StoryDetailPage'
import EventsPage from '../pages/EventsPage'
import EventDetailPage from '../pages/EventDetailPage'
import PartnerPage from '../pages/PartnerPage'
import YouthSummitPage from '../pages/YouthSummitPage'
import ContactPage from '../pages/ContactPage'
import ChangeMakerPage from '../pages/ChangeMakerPage'
import ProgramPage from '../pages/programs/ProgramPage'
import DimensionPage from '../pages/dimensions/DimensionPage'

export default function AppRoutes() {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route index element={<HomePage />} />
        <Route path="about-us" element={<AboutPage />} />
        <Route path="plc-4" element={<PlcPage />} />
        <Route path="stories/:slug" element={<StoryDetailPage />} />
        <Route path="stories" element={<StoriesPage />} />
        <Route path="events" element={<EventsPage />} />
        <Route path="events/:slug" element={<EventDetailPage />} />
        <Route path="partner-with-us" element={<PartnerPage />} />
        <Route path="youth-leadership-summit" element={<YouthSummitPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="become-a-change-maker" element={<ChangeMakerPage />} />
        <Route path="programs/:slug" element={<ProgramPage />} />
        <Route path="dimensions/:slug" element={<DimensionPage />} />
      </Route>
    </Routes>
  )
}
